import { styled } from "@mui/material/styles";
const CurrentPeriod = styled("span")(({ theme }) => ({
  fontSize: 14,
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: 0.25,
  color: theme.palette.grey[800],
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  fontFamily: "Lato",
  paddingTop: 6,
  paddingBottom: 6,
  minWidth: 223
  // Min width is set to avoid layout shift when there are changes in the content length
}));
export {
  CurrentPeriod
};
